import React, { useEffect } from "react";
import { placeholder } from "../../assets/images";

const Image = ({ imgSrc, className, preload, aspectRatio, alt, onClick }) => {
  const formattedRatio = aspectRatio?.replace(":", "/");
  useEffect(() => {
    if (preload) {
      const link = document.createElement("link");
      link.rel = "preload";
      link.as = "image";
      link.href = imgSrc;
      document.head.appendChild(link);

      return () => {
        document.head.removeChild(link);
      };
    }
  }, [imgSrc, preload]);
  const processSrc = (src) => {
    if (src?.startsWith("cdn")) {
      return `https://${src}`; // Prepend https:// to make it absolute
    }
    return src || placeholder; // Return the original src if it's already absolute
  };
  return (
    <img
      className={className}
      src={processSrc(imgSrc)}
      alt={alt || "product image"}
      style={{
        aspectRatio: formattedRatio,
      }}
      onClick={onClick}
    />
  );
};

export default Image;
